// @ts-nocheck

export * from '../../common/support/utils';

import * as R from 'ramda';

const ONBOARDING_KEY = 'onboarding';

export function saveToStorage(key, saveStates, state) {
  try {
    const item = {
      [key]: R.pick(saveStates, state),
    };
    window.localStorage.setItem(ONBOARDING_KEY, JSON.stringify(item));
    // biome-ignore lint/correctness/noUnusedVariables: ignored using `--suppress`
  } catch (e) {}
}

export function loadFromStorage(key) {
  try {
    const item = JSON.parse(window.localStorage.getItem(ONBOARDING_KEY));
    return item && item[key] ? item[key] : null;
    // biome-ignore lint/correctness/noUnusedVariables: ignored using `--suppress`
  } catch (e) {}
  return null;
}

// handle errors from UserErrors and relay props to <Input/>
export function userErrorHandler(error = {}, field) {
  if (R.path(['data', 'field'], error) !== field) {
    return {};
  }

  return {
    note: error.data.message,
    statusType: 'error',
  };
}

// setting state based on props is an anti-pattern,
// we're better off deriving state on the fly
export function mergeFromList(obj1, obj2, keyList) {
  return R.merge(R.pick(keyList, obj1), R.pick(keyList, obj2));
}
